import request from "@/utils/loginRequest";
import qs from "qs";

// 运输里程
export function getMileage() {
  return request({
    url: "/api/equipment/getMileage",
    method: "get",
  });
}
/**
 * 2.12——获取设备在线状态接口
 * */
export function onLineStatus() {
  return request({
    url: "/api/equipment/getOnlineEquipmentAmountByRiskLevel",
    method: "get",
  });
}
/**
 * 2.14——设备总数
 * */
export function equipmentAmountByType() {
  return request({
    url: "/api/equipment/getEquipmentAmountByType",
    method: "get",
  });
}
/**
 * 2.15——定位设备数量
 * */
export function equipmentAmountByLocated() {
  return request({
    url: "/api/equipment/getEquipmentAmountByLocated",
    method: "get",
  });
}
/**
 * 2.20 历史轨迹
 * */
export function getHistroyTrack(params) {
  return request({
    url: "/api/equipment/getHistroyTrack",
    method: "post",
    dataType: "json",
    data: params,
  });
}
/**
 * 2.31.根据设备编号获取工况明细信息
 * */
export function getConditionCount(data) {
  return request({
    url: "/api/equipment/getConditionCount",
    method: "post",
    // data: qs.stringify(data),
    data,
    dataType: "json",
    // headers: {
    //   "Content-Type": "application/x-www-form-urlencoded; charset=UTF-8",
    // },
  });
}
/**
 * 2.3-设备列表(有地图定位) 新
 * */
export function queryEquipmentsByPage(data) {
  return request({
    url: "/api/equipment/queryEquipmentsByPage",
    method: "post",
    data: qs.stringify(data),
    headers: {
      "Content-Type": "application/x-www-form-urlencoded; charset=UTF-8",
    },
  });
}
/**
 * 设备所属项目，状态，操作手
 * */
export function getEquDet(data) {
  return request({
    url: "/api/equipment/getEquDet",
    method: "post",
    data: qs.stringify(data),
    headers: {
      "Content-Type": "application/x-www-form-urlencoded; charset=UTF-8",
    },
  });
}
/**
 * 维保保养，清洁，维修
 * */
export function getMaintenance() {
  return request({
    url: "/api/equipment/getMaintenance",
    method: "get",
    dataType: "json",
  });
}
/**
 * 2.17-设备列表信息（所有设备列表）
 * */
export function selectList(data) {
  return request({
    url: "/api/equipment/selectList",
    method: "post",
    data: qs.stringify(data),
    headers: {
      "Content-Type": "application/x-www-form-urlencoded; charset=UTF-8",
    },
  });
}

/**
 * 获取大屏设备列表数据
 * */
export function customerScreen(type = "") {
  return request({
    url: "/api/equipment/customerScreen?type=" + type,
    method: "get",
    dataType: "json",
  });
}

/**
 * 获取重机云上的设备编号
 * */
export function craneCloudEquipmentNo() {
  return request({
    url: "/api/equipment/craneCloudEquipmentNo",
    method: "get",
    dataType: "json",
  });
}
/**
 * 2.21 设备风险列表
 * */
export function equipmentAlarmList(params) {
  return request({
    url: "/api/equipment/alarm/alarmList",
    method: "post",
    dataType: "json",
    data: params,
  });
}
/**
 * 设备风险列表导出
 * */
export function downAlarmListInfo(params) {
  return request({
    url: "/api/equipment/alarm/exportAlarms",
    method: "post",
    dataType: "json",
    responseType: "blob",
    data: params,
  });
}

/**
 * 获取报警事件个等级的数量（监控平台）
 * */
export function getRiskAmountByRiskLevel() {
  return request({
    url: "/api/equipment/alarm/riskAmountByRiskLevel",
    method: "get",
    dataType: "json",
  });
}

/**
 * 获取徐工设备工况数据
 * */
export function xgWorkConditionData(id) {
  return request({
    url: "/product/cpequipmentinformationxg/xgWorkConditionData",
    method: "get",
    dataType: "json",
    params: { id: id },
  });
}

/**
 * 获取oa人员数据
 * */
export function hrmCountData() {
  return request({
    url: "/product/cpequipmentinformationxg/hrmCountData",
    method: "get",
    dataType: "json",
  });
}

/**
 * 处理风险报警数据
 * */
export function handleWarningStatus(params) {
  return request({
    url: "/api/equipment/alarm/alarmStatus",
    method: "post",
    data: params,
  });
}
